import React, { useContext, useEffect, useRef, useState } from "react";
import clsx from "clsx";

import ThemeContext from "~/contexts/ThemeContext";
import { ProductModalInfoDescriptionFontSize } from "~/theme/models/themeModels";

import styles from "./ProductDescription.module.css";

type ProductDescriptionProps = {
  alwaysVisible?: boolean;
  description: string;
};

const ProductDescription: React.FC<ProductDescriptionProps> = ({
  alwaysVisible = false,
  description,
}) => {
  const [expanded, setExpanded] = useState(alwaysVisible);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const { template } = useContext(ThemeContext);

  const textRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (textRef.current) {
      const { scrollHeight, clientHeight } = textRef.current;
      setIsOverflowing(scrollHeight > clientHeight);
    }
  }, [description]);

  // Styles
  const fontSize =
    ProductModalInfoDescriptionFontSize[
      template.productScreen.info.descriptionFontSize
    ];
  const color = template.productScreen.info.descriptionColour;
  const expandButtonColor =
    template.productScreen.info.descriptionExpandButtonColour;

  return (
    <div className={styles.wrapper} style={{ fontSize, color }}>
      <span
        ref={textRef}
        className={clsx(
          styles.description,
          !expanded && styles.descriptionNotExtended,
        )}
      >
        {description}
      </span>
      {!alwaysVisible && isOverflowing && (
        <div
          className={styles.expandButton}
          style={{ color: expandButtonColor }}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "Show less" : "Show more"}
        </div>
      )}
    </div>
  );
};

export default ProductDescription;
